import React from 'react';
import { useNavigate } from 'react-router';
import { DisplayType, SessionFieldsFragment } from '../../../../../generated/core-api/graphql-react-query';
import useSessionCardPinContext from '../../SessionCardPinContextProvider/useSessionCardPinContext';
import { LatestDetection } from '../useSessionDetectionContext';

export default function useDetectionNavigation(
  latestDetection: LatestDetection | null,
  session?: SessionFieldsFragment | null,
) {
  const { pinnedAt } = useSessionCardPinContext();
  const pinnedAtRef = React.useRef(pinnedAt);
  const navigate = useNavigate();

  React.useEffect(() => {
    pinnedAtRef.current = pinnedAt;
  }, [pinnedAt]);

  const sessionRef = React.useRef<SessionFieldsFragment | null>(session);

  React.useEffect(() => {
    if (latestDetection?.cardId && !pinnedAtRef.current) {
      navigate(`projects/${latestDetection.projectId}/cards/${latestDetection.cardId}?displayType=${DisplayType.Detection}&detectionId=${latestDetection.id}`);
    }
  }, [latestDetection?.cardId, latestDetection?.projectId, latestDetection?.id, pinnedAtRef]);

  React.useEffect(() => {
    if (session) {
      if (session.id !== sessionRef.current?.id) {
        if (session.externalCall?.clientCard?.id) {
          const { projectId: sessionProjectId, externalCall: { clientCard: { id: cardId } } } = session;
          navigate(`projects/${sessionProjectId}/cards/${cardId}?displayType=${DisplayType.InitialDisplay}`);
        } else if (session.project.sessionStartCardId) {
          navigate(`/projects/${session.projectId}/cards/${session.project.sessionStartCardId}?displayType=${DisplayType.SessionStartDisplay}`);
        }
      }
    } else if (sessionRef.current && sessionRef.current.project.sessionEndCardId) {
      navigate(`/projects/${sessionRef.current.projectId}/cards/${sessionRef.current.project.sessionEndCardId}?displayType=${DisplayType.SessionEndDisplay}`);
    }
    sessionRef.current = session;
  }, [session]);
}
